import React, {Component} from 'react';
import {connect} from 'react-redux';
import {PageContainer, PageDescription, PageSubTitle, PageTitle} from '../../../Common/PageComponents';

import '../tournamentKit.scss';

const stateToProps = state => {
  return {
    agreement: state.agreement,
  };
};

class DigitalKitDownload extends Component {
  componentDidMount() {
    if (!this.props.agreement.digitalKit) {
      alert('리그 오브 레전드 디지털 키트 운영 정책 약관에 동의하여야 합니다.');
      this.props.history.push('/news/tournament-kit/digital-kit-download/agreement');
    }
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="토너먼트 키트" />
        <PageSubTitle title="디지털 키트 다운로드" />
        <PageDescription>다운로드를 원하는 포스터 또는 대진표를 선택해 주세요.</PageDescription>
        <div className="down_kit">
          <ul>
            <li className="poster_img">
              <p>
                <b>대회 홍보용 포스터</b>
                <br />
                (최대 출력 사이즈 520 x 750)
              </p>
              <span className="pr">
                <img src="/image/customer/kit/down_poster1_2019.jpg" alt="대회 홍보용 포스터 1" />
                <a href="/image/customer/kit/downloadKit/2019_poster01.jpg" target="_blank" download>
                  <img src="/image/customer/kit/btn_kit_down2.gif" alt="다운로드" />
                </a>
                <br />
              </span>
              <span className="pr">
                <img src="/image/customer/kit/down_poster2_2019.jpg" alt="대회 홍보용 포스터 1" />
                <a href="/image/customer/kit/downloadKit/2019_poster02.jpg" target="_blank" download>
                  <img src="/image/customer/kit/btn_kit_down2.gif" alt="다운로드" />
                </a>
              </span>
            </li>
            <li className="match">
              <p>
                <b>대진표 양식</b>
                <br />
                (최대 출력 사이즈 900 x 600)
              </p>
              <dl>
                <dt>
                  <img src="/image/customer/kit/down_m_1_2019.jpg" alt="4강 리그 대진표" />
                </dt>
                <dd>4강 리그</dd>
                <dd>
                  <a href="/image/customer/kit/downloadKit/2019_match01.jpg" target="_blank" download>
                    <img src="/image/customer/kit/btn_kit_down2.gif" alt="다운로드" />
                  </a>
                </dd>
              </dl>
              <dl>
                <dt>
                  <img src="/image/customer/kit/down_m_2_2019.jpg" alt="8강 토너먼트 대진표" />
                </dt>
                <dd>8강 토너먼트</dd>
                <dd>
                  <a href="/image/customer/kit/downloadKit/2019_match02.jpg" target="_blank" download>
                    <img src="/image/customer/kit/btn_kit_down2.gif" alt="다운로드" />
                  </a>
                </dd>
              </dl>
              <dl>
                <dt>
                  <img src="/image/customer/kit/down_m_3_2019.jpg" alt="8강 패자부활전 대진표" />
                </dt>
                <dd>8강 패자부활전</dd>
                <dd>
                  <a href="/image/customer/kit/downloadKit/2019_match03.jpg" target="_blank" download>
                    <img src="/image/customer/kit/btn_kit_down2.gif" alt="다운로드" />
                  </a>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </PageContainer>
    );
  }
}

export default connect(stateToProps)(DigitalKitDownload);
